var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSystemsIconSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.222656 1.68034V3.13867H8.00043H15.7782V1.68034V0.222005H8.00043H0.222656V1.68034Z",
    fill: "#006DC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.222656 7.99978V11.8887H8.00043H15.7782V7.99978V4.11089H8.00043H0.222656V7.99978ZM14.806 8.97201V10.9164H8.00043H1.19488V8.97201V7.02756H8.00043H14.806V8.97201Z",
    fill: "#006DC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.222656 14.319V15.7773H8.00043H15.7782V14.319V12.8607H8.00043H0.222656V14.319Z",
    fill: "#006DC0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemsIconSvg);
export default __webpack_public_path__ + "static/media/systems_iconSvg.82a0152745c8af36bf2d857d31b8769c.svg";
export { ForwardRef as ReactComponent };